import type { AxiosRequestConfig } from 'axios'
import { http, upload } from '../http'
import { URL } from './_constant'

/**
 * 房源-列表
 */
export function API_HOUSE_LIST(data?: BasicPageReq) {
  return http.post<ApiHouse.ListRes>(URL.LIST, data)
}

/**
 * 房源-全部
 */
export function API_HOUSE_ALL(data?: BasicPageReq) {
  return http.post<ApiHouse.Item[]>(URL.LIST, data)
}

/**
 * 房源-详情
 */
export function API_HOUSE_DETAIL(id: string) {
  return http.post<ApiHouse.Item>(URL.DETAIL, { id })
}

/**
 * 房源-新增
 */
export function API_HOUSE_ADD(data: ApiHouse.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 房源-删除
 */
export function API_HOUSE_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  房源-编辑
 */
export function API_HOUSE_EDIT(data: BasicUpdateOneReq<ApiHouse.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  房源-禁用
 */
export function API_HOUSE_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 房源-启用
 */
export function API_HOUSE_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 房源-排序
 */
export function API_HOUSE_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 房源-导入模板下载
 */
export function API_HOUSE_TPL(id: string) {
  return http.post<ImportTemplateRes>(URL.TPL, { id })
}

/**
 * 房源-导入
 */
export function API_HOUSE_IMPORT(file: File, communityId: string, config: AxiosRequestConfig = {}) {
  return upload(URL.IMPORT, { file, data: { communityId } }, config)
}
